export default "__VITE_ASSET__132bf70e__"